function debounce<TThis, TArgs extends unknown[]>(func: (this: TThis, ...args: TArgs) => unknown, wait: number, immediate?: boolean): (this: TThis, ...args: TArgs) => void {
    let timeout: ReturnType<typeof setTimeout> | null | undefined

    return function (this: TThis) {
        const context = this
        const args = arguments as unknown as TArgs

        clearTimeout(timeout!)
        if (immediate && !timeout) {
            func.apply(context, args)
        }
        timeout = setTimeout(function () {
            timeout = null
            if (!immediate) {
                func.apply(context, args)
            }
        }, wait)
    }
}

export {debounce}